var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowthIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 17V23.25M18.25 14.5V23.25M23.25 9.5V23.25M25.75 0.75L14.9425 11.5575C14.8844 11.6157 14.8155 11.6619 14.7395 11.6934C14.6636 11.7249 14.5822 11.7411 14.5 11.7411C14.4178 11.7411 14.3364 11.7249 14.2605 11.6934C14.1845 11.6619 14.1156 11.6157 14.0575 11.5575L9.9425 7.4425C9.8253 7.32533 9.66635 7.25951 9.50062 7.25951C9.3349 7.25951 9.17596 7.32533 9.05875 7.4425L0.75 15.75M3.25 19.5V23.25M8.25 14.5V23.25",
    stroke: "#147B58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthIcon);
export default __webpack_public_path__ + "static/media/GrowthIcon.f2ab19d544f93b9752f0bf2bbbcf823b.svg";
export { ForwardRef as ReactComponent };